<template>
  <div class="home">
    <div id="siteMaps" :style="'height:' + heights + 'px'"></div>
  </div>
</template>

<script>
import {
  initBMap,
  initInfoWindow,
  initMarker,
  initGoogleMap,
} from "@/js/mapGetterAddress";
import axios from "axios";
import RsaCrypto from "@/js/crypto";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      map: null,
      heights: 500,
      longitude: "", //经度-用于搜索
      latitude: "", //纬度-用于搜索
    };
  },
  methods: {
    isGoogle() {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyDtiVDTtym3jwAYgr1QSdytMw8ZbFferng&language=en";
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    //获取站点列表
    getSiteList(token) {
      var url = "/api/site/v2/getListByMultipleSearchFilterAndReorder";
      var params = {
        dataLogger: "",
        inverter: "",
        searchKey: "",
        reorderType: "asc",
      };
      return new Promise((resolve, reject) => {
        axios
          .post(url, RsaCrypto.encryptAES(JSON.stringify(params)), {
            headers: {
              AuthorizationKey: RsaCrypto.updatedSendKey(),
              Authorization: token,
              "Accept-Language": "en",
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            if (res.data) {
              if (res.data.code == 200) {
                console.log(res.data);
                console.log(RsaCrypto.decryptAES(res.data.data));
                resolve(JSON.parse(RsaCrypto.decryptAES(res.data.data)));
              }
            }
          });
      });
    },
  },
  mounted() {
    var query = this.$route.query;
    this.heights = window.innerHeight;
    console.log(window.innerHeight);
    if (
      query.hasOwnProperty("type") &&
      query.hasOwnProperty("token") &&
      query.hasOwnProperty("pubKey")
    ) {
      var token = query.token;
      RsaCrypto.updatedKey(decodeURI(query.pubKey));
      // console.log(decodeURIComponent(query.pubKey))
      // console.log(decodeURI(query.pubKey))
      if (query.type == "Google") {
        this.isGoogle();
        this.getSiteList(token).then((res) => {
          setTimeout(() => {
            initGoogleMap(res, this);
          }, 500);
        });
      }
      if (query.type == "test-map") {
        initBMap(
          [
            {
              alarm_remind: 1,
              auth_enable: 0,
              model_version: 4,
              role: 1,
              system_datetime: 1778296743,
              latitude: "-18.355910",
              system_code: 14,
              battery_soc: "66",
              solar_yield: "0.0",
              system_mode: 0,
              alarm_status: 0,
              battery_type: 5,
              ac_source: "0.0",
              auth_expire: 0,
              id: 11289,
              work_model: 1,
              ckled_version: 0,
              bms_provide: 0,
              comm_type: 0,
              longitude: "24.580290",
              creator: {
                name: "Muhammad Pandor ",
                header: "",
                id: "5278",
                account: "muhammadpandor@gmail.com",
              },
              system_id: "CJ0523070016E5",
              consumption: "717.0",
              comm_version: 230083,
              auth_lock: 0,
              inverter_nums: 1,
              running_type: 2,
              battery_status: 1,
              tags: "",
              last_update_time: 1778296744972,
              update_num: 0,
              system_config: 0,
              system_type: "01000200",
              dc_voltage: "52.9",
              name: "*CK Home",
              online: 1,
              location: "",
            },
            {
              alarm_remind: 1,
              auth_enable: 0,
              model_version: 0,
              role: 1,
              system_datetime: 1778296742,
              latitude: "24.474510",
              system_code: 265,
              battery_soc: "0",
              solar_yield: "0.0",
              system_mode: 0,
              alarm_status: 2,
              battery_type: 6,
              ac_source: "0.0",
              auth_expire: 0,
              id: 19830,
              work_model: 1,
              ckled_version: 0,
              bms_provide: 0,
              comm_type: 0,
              longitude: "118.246977",
              creator: {
                name: "yyz",
                header: "/group1/M00/00/53/CNKEvGS00eyAE9ypAABNQJMEK2E047.png",
                id: "18",
                account: "yyz37@qq.com",
              },
              system_id: "AAA001050200080N",
              consumption: "0.0",
              comm_version: 9001,
              auth_lock: 0,
              inverter_nums: 2,
              running_type: 0,
              battery_status: 3,
              tags: "",
              last_update_time: 1778296742362,
              update_num: 0,
              system_config: 2,
              system_type: "01000E00",
              dc_voltage: "0.0",
              name: "4楼INGE T20测试",
              online: 1,
              location: "F6FW+RQ5 Siming District, Xiamen, Fujian, China",
            },
          ],
          this
        );
      } else {
        this.getSiteList(token).then((res) => {
          initBMap(res, this);
        });
      }
    }
  },
};
</script>

<style>
* {
  padding: 0px;
  margin: 0px;
}

#siteMaps {
  width: 100%;
}
</style>
